import React from 'react';
import { AlertTriangle, Clock, TrendingDown, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-gray-50 px-4 border-y border-gray-200" data-id="element-134">
      <div className="max-w-5xl mx-auto" data-id="element-135">
        <div className="text-center mb-12" data-id="element-136">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-137">
            El "Techo de Cristal" del{' '}
            <span className="text-brand-red" data-id="element-138">trabajo manual.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-139">
          <div className="space-y-6 text-lg text-gray-700" data-id="element-140">
            <p className="font-semibold text-xl text-gray-900" data-id="element-141">
              La mayoría de los profesionales digitales están atrapados en una
              trampa:{' '}
              <span className="bg-brand-yellow px-1" data-id="element-142">venden su tiempo.</span>
            </p>

            <p data-id="element-143">
              Si no estás frente a la pantalla moviendo datos, respondiendo
              correos o calificando leads, no ganas dinero.
            </p>

            <ul className="space-y-4 mt-8" data-id="element-144">
              <li className="flex items-start gap-3" data-id="element-145">
                <TrendingDown className="w-6 h-6 text-brand-red flex-shrink-0 mt-1" data-id="element-146" />
                <span className="font-medium" data-id="element-147">
                  Tu negocio no escala porque tus manos son el cuello de
                  botella.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-148">
                <Clock className="w-6 h-6 text-brand-red flex-shrink-0 mt-1" data-id="element-149" />
                <span className="font-medium" data-id="element-150">
                  Pierdes clientes potenciales por falta de respuesta inmediata.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-151">
                <XCircle className="w-6 h-6 text-brand-red flex-shrink-0 mt-1" data-id="element-152" />
                <span className="font-medium" data-id="element-153">
                  Te sientes superado por la complejidad técnica de otras
                  herramientas.
                </span>
              </li>
            </ul>

            <div className="mt-8 p-6 bg-white border-l-4 border-brand-red shadow-md rounded-r-lg" data-id="element-154">
              <p className="font-bold text-xl text-gray-900 italic" data-id="element-155">
                "Es hora de dejar de ser el operario y empezar a ser el
                arquitecto."
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-156">
            <div className="absolute inset-0 bg-brand-red rounded-2xl transform rotate-3 opacity-10" data-id="element-157"></div>
            <div className="bg-white p-8 rounded-2xl shadow-xl relative border border-gray-100 flex flex-col items-center justify-center min-h-[400px]" data-id="element-158">
              <AlertTriangle className="w-32 h-32 text-brand-red mb-6 opacity-80" data-id="element-159" />
              <h3 className="text-2xl font-bold text-center text-gray-900 mb-2" data-id="element-160">
                La Trampa del Tiempo
              </h3>
              <p className="text-center text-gray-500" data-id="element-161">
                Más horas trabajadas ≠ Más ingresos
              </p>

              <div className="w-full mt-8 space-y-3" data-id="element-162">
                <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-163">
                  <div className="h-full bg-brand-red w-full" data-id="element-164"></div>
                </div>
                <div className="flex justify-between text-xs font-bold text-gray-500 uppercase" data-id="element-165">
                  <span data-id="element-166">Horas de trabajo</span>
                  <span data-id="element-167">100% Agotado</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}